/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import ChoroplethReachMap from 'statsradio/components/maps/ChoroplethReachMap';
import GeolocationReach from 'statsradio/modules/dashboard/domain/GeolocationReach';
import Colors from '../../../../../../common/themes/Colors';
import { GeoMapLayoutData } from '../../../domain/GeoMapLayout';

const THEME = {
  minColor: '#e6ebf5',
  maxColor: '#003399',
  hoverColor: Colors.primary,
  tooltipBackgroundColor: '#fff',
};

type Props = {
  geolocalisation: GeolocationReach[];
  layout: GeoMapLayoutData;
  zoomable?: boolean;
  aspectRatio?: number;
  onMapBoundsUpdated: (viewport: { center: [number, number], zoom: number }) => void;
  t: any;
}

function GeoMapByRegion({ aspectRatio, geolocalisation, layout, t, zoomable, onMapBoundsUpdated = () => {} }: Props) {
  return (
    <ChoroplethReachMap
      id="geomap"
      map={layout.map}
      geolocalisation={geolocalisation}
      viewport={layout.mapBounds}
      onViewportChange={onMapBoundsUpdated}
      zoomable={zoomable}
      aspectRatio={aspectRatio}
      reachLabel={t('reach')}
      theme={THEME}
      showLegend
    />
  );
}

export default translate()(GeoMapByRegion);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/components/geolocalisation/map/GeoMapByRegion.js